import iconBackground from "@layouts/betto/assets/icon-background.svg";
import styled from "styled-components";
import { BTTO_PROFILE_COLORS } from "../../shared/elements";

export const AvatarRoot = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	width: ${({ $size }) => $size}px;
	height: ${({ $size }) => $size}px;
	border-radius: 12px;
	background: url(${iconBackground}) no-repeat center / 100% 100%;
	position: relative;
	overflow: hidden;
`;

export const AvatarLetter = styled.span`
	color: ${BTTO_PROFILE_COLORS.text};
	font-size: ${({ $size }) => Math.round($size * 0.38)}px;
	font-weight: 700;
	line-height: 1;
	letter-spacing: -0.02em;
	text-transform: uppercase;
	user-select: none;
`;

export const AvatarImage = styled.img`
	width: 56%;
	height: 56%;
	object-fit: contain;
	filter: brightness(0) invert(1);
	opacity: 0.92;
`;
